import { InvoiceDetails } from './InvoiceDetails';

export class InvoiceDetailsResponse {
  public details: InvoiceDetails;
  public status: 'OK' | 'ARCHIVED' | 'TOO_LARGE' | 'NOT_AVAILABLE';
}
